import React, { useEffect, useState } from "react";
import TipWinnerModal from "./TipWinnerModal";

/**
 * Global component that listens for winner modal events through localStorage
 * This component should be placed at the top level of your application (e.g., in App.jsx)
 */
export default function WinnerModalManager() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [winnerData, setWinnerData] = useState(null);

  useEffect(() => {
    // Check if we should show the modal on mount
    const checkModalState = () => {
      try {
        const shouldShowModal =
          localStorage.getItem("winner_modal_open") === "true";
        if (shouldShowModal) {
          const storedData = localStorage.getItem("winner_modal_data");
          if (storedData) {
            setWinnerData(JSON.parse(storedData));
            setIsModalOpen(true);
          }
        } else {
          setIsModalOpen(false);
        }
      } catch (error) {
        console.error("Error reading winner modal state:", error);
      }
    };

    // Check initial state
    checkModalState();

    // Listen for updates to the modal state
    const handleModalUpdate = () => {
      checkModalState();
    };

    window.addEventListener("winner_modal_update", handleModalUpdate);
    window.addEventListener("storage", (e) => {
      if (e.key === "winner_modal_open" || e.key === "winner_modal_data") {
        checkModalState();
      }
    });

    return () => {
      window.removeEventListener("winner_modal_update", handleModalUpdate);
      window.removeEventListener("storage", handleModalUpdate);
    };
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Clear localStorage when closing
    try {
      localStorage.removeItem("winner_modal_open");
      localStorage.removeItem("winner_modal_data");
    } catch (error) {
      console.error("Error clearing winner modal data:", error);
    }
  };

  // Only render the modal if it's open and we have data
  return isModalOpen && winnerData ? (
    <TipWinnerModal entry={winnerData} onClose={handleCloseModal} />
  ) : null;
}
